// A flat list of one-off milestones. `unlock` is idempotent and returns true
// only the first time, which is exactly what the toast wants to know.
import { ACHIEVEMENTS, type AchievementDef } from "./config.ts";

export class Achievements {
  private readonly done = new Set<string>();
  /** running tallies the milestones are checked against */
  readonly stats: Record<string, number> = { trees: 0, builds: 0, fish: 0, days: 0 };

  has(id: string): boolean {
    return this.done.has(id);
  }

  get earned(): number {
    return this.done.size;
  }

  get total(): number {
    return ACHIEVEMENTS.length;
  }

  /** True when this call is what earned it. */
  unlock(id: string): boolean {
    if (this.done.has(id)) return false;
    if (!ACHIEVEMENTS.some((a) => a.id === id)) return false;
    this.done.add(id);
    return true;
  }

  /** Bump a tally and unlock anything that tally crosses. */
  bump(key: string, by = 1): string[] {
    this.stats[key] = (this.stats[key] ?? 0) + by;
    const earned: string[] = [];
    if (key === "trees" && this.stats.trees! >= 50 && this.unlock("lumberjack")) earned.push("lumberjack");
    if (key === "builds" && this.stats.builds! >= 10 && this.unlock("builder")) earned.push("builder");
    return earned;
  }

  list(): (AchievementDef & { done: boolean })[] {
    return ACHIEVEMENTS.map((a) => ({ ...a, done: this.done.has(a.id) }));
  }

  toJSON(): { done: string[]; stats: Record<string, number> } {
    return { done: [...this.done], stats: { ...this.stats } };
  }

  load(data: { done?: string[]; stats?: Record<string, number> } | undefined): void {
    this.done.clear();
    for (const id of data?.done ?? []) this.done.add(id);
    Object.assign(this.stats, data?.stats ?? {});
  }
}
